// extracted by mini-css-extract-plugin
export default {"link":"wHGCLp","image":"JfCtA6","root":"BajhNJ"};